import type { TimeHTMLAttributes } from "react";

import ClientOnly from "./ClientOnly";

export function Time({
  dateTime,
  children,
  ...props
}: Omit<TimeHTMLAttributes<HTMLTimeElement>, "dateTime"> & {
  dateTime: Required<TimeHTMLAttributes<HTMLTimeElement>>["dateTime"];
}) {
  return (
    <time dateTime={dateTime} {...props}>
      <ClientOnly>{children}</ClientOnly>
    </time>
  );
}
